import { createContext, useContext, useState } from "react";

interface SelectedMatchContextValue {
    matchIds: number[];
    setMatchIds: (ids: number[]) => void;
    tournamentName: string | null;
    setTournamentName: (name: string | null) => void;
}

const SelectedMatchContext = createContext<SelectedMatchContextValue | undefined>(undefined);

export const SelectedMatchProvider = ({ children }: { children: React.ReactNode }) => {
    const [matchIds, setMatchIds] = useState<number[]>([]);
    const [tournamentName, setTournamentName] = useState<string | null>(null);

    return (
        <SelectedMatchContext.Provider
            value={{
                matchIds,
                setMatchIds,
                tournamentName,
                setTournamentName,
            }}
        >
            {children}
        </SelectedMatchContext.Provider>
    );
};

export const useSelectedMatch = (): SelectedMatchContextValue => {
    const context = useContext(SelectedMatchContext);
    if (!context) {
        throw new Error("useSelectedMatch must be used within a SelectedMatchProvider");
    }
    return context;
};
